export default async ({ store }) => {
  try {
    store.dispatch('account/initDeviceId');
    await store.dispatch('account/initAccount');
    if (store.state.account.isLoggedIn) {
      await store.dispatch('account/fetchUsersMessages');
    }
  }
  // eslint-disable-next-line no-empty
  catch (error) {
  }
};
